import { createIcon } from './_icon';

// home-open
const HomeSolidIcon = createIcon(() => (
	<svg width="1em" height="1em" fill="none" viewBox="0 0 24 24">
		<path fill="currentColor" d="m21 8.524-9-7.312-9 7.312V21h7v-7h4v7h7V8.524Z" />
	</svg>
));

export default HomeSolidIcon;
